module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cmslist"
  }, [_c('div', {
    staticClass: "container_wrap"
  }, [_c('el-breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, _vm._l((_vm.breadData), function(item, index) {
    return _c('el-breadcrumb-item', {
      key: index
    }, [_c('a', [_vm._v(_vm._s(item.name))])])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "left_and_right_container"
  }, [_c('div', {
    staticClass: "container_left"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "单位简章",
      "name": "单位简章"
    }
  }, [_c('div', {
    staticClass: "container_left_richtext html-data",
    domProps: {
      "innerHTML": _vm._s(_vm.schoolDetail.content1)
    }
  })]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "动态",
      "name": "动态"
    }
  }, [_c('div', {
    staticClass: "container_left_newslistitem_content"
  }, _vm._l((_vm.newsListData), function(item, index) {
    return _c('news-list-item', {
      key: index,
      staticClass: "container_left_newslistitem",
      attrs: {
        "specialTagName": "最新",
        "NewsItemData": item
      },
      nativeOn: {
        "click": function($event) {
          return _vm.itemClickFun(item)
        }
      }
    })
  }), 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "招生简章",
      "name": "招生简章"
    }
  }, [_c('div', {
    staticClass: "container_left_richtext html-data",
    domProps: {
      "innerHTML": _vm._s(_vm.schoolDetail.content2)
    }
  })])], 1), _vm._v(" "), (_vm.activeName == '动态') ? _c('el-button', {
    staticClass: "publish_cms_btn",
    attrs: {
      "type": "primary",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.publicNewsFun()
      }
    }
  }, [_vm._v("发布")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "container_right"
  }, [_c('div', {
    staticClass: "right_content"
  }, [_c('div', {
    staticClass: "right_content_title"
  }, [_vm._v("学校信息")]), _vm._v(" "), _c('div', {
    staticClass: "right_content_pic"
  }, [_c('img', {
    attrs: {
      "src": _vm.schoolDetail.certificatepic && _vm.schoolDetail.certificatepic.length > 0 ? _vm.schoolDetail.certificatepic[0].url : ''
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right_content_title"
  }, [_vm._v("\n            " + _vm._s(_vm.schoolDetail.name) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "right_content_subtitle"
  }, [_vm._v("\n            " + _vm._s(_vm.schoolDetail.content) + "\n          ")])])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d910380","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/cms/CmsPosition.vue
// module id = 1145
// module chunks = 0